
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class ColorCodeTriangle extends Vue {
    @Prop({ type: String, required: true }) readonly colorCode!: string;
  }
